export default {"src":"/_next/static/image/public/images/ic_star_filled.0ef39388496cbb7e63bbc1f4133a1a10.svg","height":29,"width":30};